import debounce from "../../utils/debounce";
import constants from "../../constants";

const setUpOurHistoryTimeline = () => {
  const timelines = document.querySelectorAll("[data-history-timeline]");

  if (!timelines.length) {
    return;
  }

  timelines.forEach((timeline) => {
    const viewport = timeline.querySelector("[data-history-timeline-viewport]");
    const track = timeline.querySelector("[data-history-timeline-track]");
    const prevButton = timeline.querySelector("[data-history-timeline-prev]");
    const nextButton = timeline.querySelector("[data-history-timeline-next]");

    if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) {
      return;
    }

    const getTimelineItems = () => Array.from(
      track.querySelectorAll("[data-history-timeline-item]")
    ).filter((item) => item instanceof HTMLElement);

    const getColumnsPerView = () => {
      if (window.innerWidth >= constants.screenWidthBreakpoints.lg) {
        return 3;
      }

      if (window.innerWidth >= constants.screenWidthBreakpoints.md) {
        return 2;
      }

      return 1;
    };

    const getTrackGap = () => {
      const trackStyles = window.getComputedStyle(track);
      return Number.parseFloat(trackStyles.columnGap || trackStyles.gap || "0") || 0;
    };

    const syncItemWidths = () => {
      const columnsPerView = getColumnsPerView();
      const gapValue = getTrackGap();
      const availableWidth = Math.max(
        viewport.clientWidth - (gapValue * (columnsPerView - 1)),
        0
      );

      track.style.setProperty(
        "--history-timeline-item-width",
        `${availableWidth / columnsPerView}px`
      );
    };

    const getSnapPoints = () => {
      const timelineItems = getTimelineItems();
      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const columnsPerView = getColumnsPerView();
      const snapPoints = [];

      if (maxScrollLeft <= 0 || !timelineItems.length) {
        return [0];
      }

      for (let index = 0; index < timelineItems.length; index += columnsPerView) {
        snapPoints.push(Math.min(timelineItems[index].offsetLeft, maxScrollLeft));
      }

      snapPoints.unshift(0);
      snapPoints.push(maxScrollLeft);

      return Array.from(new Set(
        snapPoints.map((point) => Math.round(point))
      )).sort((left, right) => left - right);
    };

    const updateButtons = () => {
      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const canScroll = maxScrollLeft > 2;

      prevButton.disabled = !canScroll || viewport.scrollLeft <= 2;
      nextButton.disabled = !canScroll || viewport.scrollLeft >= maxScrollLeft - 2;
    };

    const scrollTimeline = (direction) => {
      const snapPoints = getSnapPoints();
      const currentScrollLeft = viewport.scrollLeft;

      let targetPoint = direction > 0
        ? snapPoints.find((point) => point > currentScrollLeft + 2)
        : [...snapPoints].reverse().find((point) => point < currentScrollLeft - 2);

      if (typeof targetPoint !== "number") {
        targetPoint = direction > 0 ? snapPoints[snapPoints.length - 1] : snapPoints[0];
      }

      viewport.scrollTo({
        left: targetPoint,
        behavior: "smooth",
      });
    };

    prevButton.addEventListener("click", () => {
      scrollTimeline(-1);
    });

    nextButton.addEventListener("click", () => {
      scrollTimeline(1);
    });

    viewport.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", debounce(() => {
      syncItemWidths();
      updateButtons();
    }, 120));

    syncItemWidths();
    updateButtons();
  });
};

export default setUpOurHistoryTimeline;
